import { render, staticRenderFns } from "./FlightPaxList.vue?vue&type=template&id=6bdd4074&"
import script from "./FlightPaxList.vue?vue&type=script&lang=js&"
export * from "./FlightPaxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports